export default __webpack_public_path__ + "ku_dark.a0d762e7.svg";